import { gql } from 'graphql-request'
import { QueryNavigationItem } from './navigation-element'
import { FragmentLinkReferences } from './references'
import { ResponsiveImage } from './responsive-image'

export const queryCustomerId = gql`
  query customerCollectionQuery($locale: String!, $slug: String!) {
    customerCollection(locale: $locale, where: { slug: $slug }, limit: 1) {
      items {
        sys {
          id
        }
      }
    }
  }
`

export const datoCustomerContentQuery = gql`
query customerContentQuery($marketId: [ItemId]!, $locale: SiteLocale!, $slug: String!) {
    customerModel(locale: $locale,fallbackLocales: [en], filter: { slug: { eq: $slug }, enabledMarkets: { anyIn: $marketId} }) {
      id
      name
      slug
      title(locale: $locale)
      customerType
      description(locale: $locale) {
        value
      }
      storyText(locale: $locale) {
        value
        links {
          ...FragmentLinkReferences
        }
        blocks {
          __typename
          id
          file {
            id
            format
            responsiveImage(imgixParams: {auto: [format, compress]}) {
              ...responsiveImageFragment
            }
          }
        }
        inlineBlocks
      }
      logo {
        url
        width
        height
        responsiveImage(imgixParams: {auto: [format, compress]}) {
          ...responsiveImageFragment
        }
      }
      quoteAuthor
      quote(locale: $locale)
      image {
        title
        url
        width
        height
        responsiveImage {
          ...responsiveImageFragment
        }
      }
      video {
        id
        videoId
        cover
        videoSource
        thumbnail {
          title
          url
          width
          height
          responsiveImage {
            ...responsiveImageFragment
          }
        }
      }
      benefits {
        __typename
        ... on BenefitBlockModelRecord {
          id
          number
          unit
          title
        }
        ... on BlockBenefitsListingModelRecord {
          benefits {
            id
            number
            unit
            title
          }
        }
      }
      actionLabel {
        ... on MicrocopyModelRecord {
          id
          key
        }
      }
      metaTags(locale: $locale)
      marketsMetaTags(locale: $locale)
      metaImage {
        url
      }
      enabledMarkets {
        id
        title
        localName
        countryIsoCode
        enabledLanguages
        defaultLanguage
        _allSlugPrefixLocales {
          locale
          value
        }
      }
      enabledLocales
      _allEnabledLocalesLocales {
        locale
        value
      }
      downloadAction {
        ...FragmentNavigationItem
      }
      integrations {
        id
        title
        label
        logo {
          url
        }
        slug
        categories {
          id
          title
          type: typeField
        }
        markets {
          id
          title
          countryIsoCode
        }
      }
      cta {
        id
        title
        text {
          value
        }
        action {
          ...FragmentNavigationItem
        }
        secondaryAction {
          ...FragmentNavigationItem
        }
        anchor
        theme
      }
    }
  }
  ${QueryNavigationItem}
  ${FragmentLinkReferences}
  ${ResponsiveImage}
`

export const datoCustomerContentQueryFallback = gql`
query customerContentQuery($marketId: [ItemId]!, $locale: SiteLocale!, $slug: String!) {
    customerModel(fallbackLocales: [en], filter: { slug: { eq: $slug }, enabledMarkets: { anyIn: $marketId} }) {
      id
      slug
      name
      title(locale: $locale)
      customerType
      description(locale: $locale) {
        value
      }
      storyText(locale: $locale) {
        value
        links {
          ...FragmentLinkReferences
        }
        blocks {
          __typename
          id
          file {
            id
            format
            responsiveImage(imgixParams: {auto: [format, compress]}) {
              ...responsiveImageFragment
            }
          }
        }
        inlineBlocks
      }
      logo {
        url
        width
        height
      }
      quoteAuthor
      quote(locale: $locale)
      image {
        title
        url
        width
        height
        responsiveImage {
          ...responsiveImageFragment
        }
      }
      video {
        id
        videoId
        cover
        videoSource
        thumbnail {
          title
          url
          width
          height
          responsiveImage {
            ...responsiveImageFragment
          }
        }
      }
      benefits {
        __typename
        ... on BenefitBlockModelRecord {
          id
          number
          unit
          title
        }
        ... on BlockBenefitsListingModelRecord {
          benefits {
            id
            number
            unit
            title
          }
        }
      }
      actionLabel {
        ... on MicrocopyModelRecord {
          id
          key
        }
      }
      metaTags(locale: $locale)
      marketsMetaTags(locale: $locale)
      metaImage {
        url
      }
      enabledMarkets {
        id
        title
        localName
        countryIsoCode
        enabledLanguages
        defaultLanguage
        _allSlugPrefixLocales {
          locale
          value
        }
      }
      enabledLocales
      _allEnabledLocalesLocales {
        locale
        value
      }
      downloadAction {
        ...FragmentNavigationItem
      }
      integrations {
        id
        title
        label
        logo {
          url
        }
        slug
        categories {
          id
          title
          type: typeField
        }
      }
    }
  }
  ${QueryNavigationItem}
  ${FragmentLinkReferences}
  ${ResponsiveImage}
`
